import { SocialMediaCategory, SocialMediaPlatform } from '@services/types/api';

export const FIELDS: {
  [key in SocialMediaCategory]?: {
    [key in SocialMediaPlatform]?: {
      name: string;
      label: string;
      type: 'text' | 'textarea' | 'file';
      placeholder?: string;
      required?: boolean;
    }[];
  };
} = {
  [SocialMediaCategory.CopyrightViolation]: {
    [SocialMediaPlatform.TIKTOK]: [
      {
        name: 'email',
        label: 'Email',
        type: 'text',
        required: true,
      },
      {
        name: 'full_name',
        label: 'Full Name',
        type: 'text',
        required: true,
      },
      {
        name: 'copyright_owner',
        label: 'Copyright Owner',
        type: 'text',
        required: true,
      },
      {
        name: 'customer_tiktok_account',
        label: 'Customer TikTok Account',
        type: 'text',
      },
      {
        name: 'original_work',
        label: 'Original Work',
        type: 'textarea',
        required: true,
      },
      {
        name: 'report_content',
        label: 'Report Content',
        type: 'textarea',
        required: true,
      },
      {
        name: 'phone_number',
        label: 'Phone Number',
        type: 'text',
      },
      {
        name: 'address',
        label: 'Address',
        type: 'text',
      },
      {
        name: 'authorization_file',
        label: 'Authorization File',
        type: 'file',
        required: true,
      },
    ],
  },
  [SocialMediaCategory.Impersonation]: {
    [SocialMediaPlatform.TIKTOK]: [
      {
        name: 'email',
        label: 'Email',
        type: 'text',
        required: true,
      },
      {
        name: 'full_name',
        label: 'Full Name',
        type: 'text',
        required: true,
      },
      {
        name: 'copyright_owner',
        label: 'Copyright Owner',
        type: 'text',
        required: true,
      },
      {
        name: 'customer_tiktok_account',
        label: 'Customer TikTok Account',
        type: 'text',
      },
      {
        name: 'original_work',
        label: 'Original Work',
        type: 'textarea',
        required: true,
      },
      {
        name: 'report_content',
        label: 'Report Content',
        type: 'textarea',
        required: true,
      },
      {
        name: 'phone_number',
        label: 'Phone Number',
        type: 'text',
      },
      {
        name: 'address',
        label: 'Address',
        type: 'text',
      },
      {
        name: 'authorization_file',
        label: 'Authorization File',
        type: 'file',
        required: true,
      },
    ],
  },
};

export const checkIfHasAutoSubmissionForm = (
  category: SocialMediaCategory,
  platform: SocialMediaPlatform,
): boolean => {
  return !!FIELDS[category]?.[platform];
};

export const getAutoSubmissionAPIEndpoint = (
  category: SocialMediaCategory,
  platform: SocialMediaPlatform,
): string => {
  if (!checkIfHasAutoSubmissionForm(category, platform)) {
    throw new Error(`No auto submission form available for ${category} on ${platform}`);
  }

  switch (category) {
    case SocialMediaCategory.CopyrightViolation:
      switch (platform) {
        case SocialMediaPlatform.TIKTOK:
          return '/submit-tiktok-copyright';
        default:
          throw new Error(`No API endpoint for ${platform} under ${category}`);
      }
    case SocialMediaCategory.Impersonation:
      switch (platform) {
        case SocialMediaPlatform.TIKTOK:
          return '/submit-tiktok-impersonation';
        default:
          throw new Error(`No API endpoint for ${platform} under ${category}`);
      }
    default:
      return '';
  }
};

export const transformAutoSubmissionData = (
  category: SocialMediaCategory,
  platform: SocialMediaPlatform,
  data: any,
): any => {
  if (!checkIfHasAutoSubmissionForm(category, platform)) {
    throw new Error(`No auto submission form available for ${category} on ${platform}`);
  }

  const transformedData = { ...data };

  switch (category) {
    case SocialMediaCategory.CopyrightViolation:
      switch (platform) {
        case SocialMediaPlatform.TIKTOK:
          transformedData.report_content = transformedData.report_content.split('\n').join(',');
          transformedData.original_work = transformedData.original_work.split('\n').join(',');
          return transformedData;
        default:
          return transformedData;
      }
    case SocialMediaCategory.Impersonation:
      switch (platform) {
        case SocialMediaPlatform.TIKTOK:
          transformedData.report_content = transformedData.report_content.split('\n').join(',');
          transformedData.original_work = transformedData.original_work.split('\n').join(',');
          return transformedData;
        default:
          return transformedData;
      }
    default:
      return transformedData;
  }
};
